import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { CloseIcon } from '@wf-sl/common-icons'
import { Button } from '@wf-common/atoms'

import { TooltipButton } from '../button/tooltip-button'
import Tooltip from '../tooltip/tooltip'

import styles from './common.module.css'
import specificStyles from './iterator.module.css'

const propTypes = {
    addButtonDisabled: PropTypes.bool,
    addButtonLabel: PropTypes.string,
    addButtonTooltip: PropTypes.string,
    disabled: PropTypes.bool,
    footerButtonClassName: PropTypes.string,
    footerClassName: PropTypes.string,
    itemClassName: PropTypes.string,
    maxItems: PropTypes.number,
    minItems: PropTypes.number,
    onAdd: PropTypes.func,
    onRemove: PropTypes.func
}

const defaultProps = {
    addButtonLabel: 'Add another',
    disabled: false,
    minItems: 1,
    onAdd: () => {},
    onRemove: () => {}
}

function Iterator(props) {
    const {
        addButtonDisabled,
        addButtonLabel,
        addButtonTooltip,
        children,
        className,
        disabled,
        footerButtonClassName,
        footerClassName,
        itemClassName,
        maxItems,
        minItems,
        onAdd,
        onRemove
    } = props
    const composedClassName = cx(styles['iterator'], className)
    const onAddClick = e => {
        e.preventDefault()
        onAdd()
    }
    const disableAddButton = disabled || addButtonDisabled || React.Children.count(children) >= maxItems
    const composedFooterButtonClassName = cx(styles['add-button'], 't3sel-iterator-add-button', footerButtonClassName)

    const buttonProps = {
        children: addButtonLabel,
        disabled: disableAddButton,
        onClick: onAddClick
    }

    const addButton = !addButtonTooltip ? (
        <Button {...buttonProps} className={composedFooterButtonClassName} />
    ) : (
        <TooltipButton {...buttonProps} wrapperClassName={composedFooterButtonClassName} />
    )

    return (
        <div className={composedClassName}>
            <div className={styles['iterator-content']}>
                {React.Children.map(children, (child, index) => (
                    <div className={cx(styles['iterator-item'], specificStyles['iterator-item'], itemClassName)}>
                        {child}
                        {React.Children.count(children) > minItems && (
                            <CloseIcon
                                className={cx(
                                    styles['close-icon'],
                                    {
                                        [styles['close-icon-disabled']]: disabled
                                    },
                                    't3sel-iterator-close-icon'
                                )}
                                onClick={() => (disabled ? {} : onRemove(index))}
                            />
                        )}
                    </div>
                ))}
            </div>
            <div className={cx(styles['iterator-footer'], footerClassName)}>
                {!addButtonTooltip ? (
                    addButton
                ) : (
                    <Tooltip content={addButtonTooltip} placement="top">
                        {addButton}
                    </Tooltip>
                )}
            </div>
        </div>
    )
}

Iterator.propTypes = propTypes
Iterator.defaultProps = defaultProps

export default Iterator
